module.exports = __webpack_public_path__ + "static/media/resize.fc577800.gif";